import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,

  userDetails: {
    _id: "",
    name: "",
    email: "",
    photo:"",
    loginMethod:"",
    rewardCount:0,
    phone: "",
    isLoggedIn: false,

    // 🛒 CART
    cart: [], // [{ _id, name, price, qty }]
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    /* ---------------- USER ---------------- */
    setUser: (state, action) => {
      state.userDetails = {
        ...state.userDetails,
        ...action.payload,
        isLoggedIn: true,
      };
    },

    clearUser: (state) => {
      state.userDetails = initialState.userDetails;
    },

    /* ---------------- CART ---------------- */

    // ➕ PUSH / INCREMENT
    addToCart: (state, action) => {
      const item = action.payload;

      const existing = state.userDetails.cart.find(
        (p) => p._id === item._id
      );

      if (existing) {
        existing.qty += 1;
      } else {
        state.userDetails.cart.push({
          ...item,
          qty: 1,
        });
      }
    },

    // ➖ DECREMENT / POP
    removeFromCart: (state, action) => {
      const {_id} = action.payload;

      const existing = state.userDetails.cart.find(
        (p) => p._id === _id
      );

      if (!existing) return;

      if (existing.qty > 1) {
        existing.qty -= 1;
      } else {
        state.userDetails.cart = state.userDetails.cart.filter(
          (p) => p._id !== _id
        );
      }
    },

    // 🧹 CLEAR FULL CART
    clearCart: (state) => {
      state.userDetails.cart = [];
    },
  },
});

export const {
  setUser,
  clearUser,
  addToCart,
  removeFromCart,
  clearCart,
} = userSlice.actions;

export default userSlice.reducer;
